import { atom } from "jotai";

export interface MagnitePrebidJS {
  isReady: boolean;
}

export const magnitePrebidJSAtom = atom<MagnitePrebidJS>({
  isReady: false,
});
